import { loadFirebaseAuth } from "./firebase";
import { email_regex } from "../consts/regex";
import {
  login_user,
  is_login_validation_completed,
  catch_error,
} from "./functions";

var login_email_validated = false;
var login_password_validated = false;
var email = "";
var password = "";
//detect email changes to validate the input
jQuery(document).ready(function ($) {
  $(document).on("input focus", "#login-email", function (e) {
    email = e.target.value;

    if (email.endsWith(" ") || email.startsWith(" ")) {
      email = email.replace(" ", "");
    }

    switch (true) {
      case !email:
        login_email_validated = false;
        is_login_validation_completed(
          login_email_validated,
          login_password_validated
        );
        break;
      case !email_regex.test(email):
        login_email_validated = false;
        is_login_validation_completed(
          login_email_validated,
          login_password_validated
        );
        break;
      default:
        login_email_validated = true;
        is_login_validation_completed(
          login_email_validated,
          login_password_validated
        );
        break;
    }
  });

  //detect password changes to validate the input
  $(document).on("input focus", "#login-password", function (e) {
    password = e.target.value;
    switch (true) {
      case !password || password.length == 0:
        login_password_validated = false;
        is_login_validation_completed(
          login_email_validated,
          login_password_validated
        );
        break;

      default:
        login_password_validated = true;
        is_login_validation_completed(
          login_email_validated,
          login_password_validated
        );
    }
  });

  $(document).on("submit", "#form__login", function (e) {
    e.preventDefault();
    const firebaseAuth = loadFirebaseAuth();
    if (login_email_validated && login_password_validated) {
      $("#login_submit").addClass("button--loading");
      login_user(firebaseAuth, email, password);
    }
  });

  if (JSON.parse(localStorage.getItem("login_result"))?.is_logged_in) {
    if (JSON.parse(localStorage.getItem("login_result"))?.expiry_date) {
      if (
        JSON.parse(localStorage.getItem("login_result"))?.expiry_date <
        Date.now()
      ) {
        const firebaseAuth = loadFirebaseAuth();
        firebaseAuth.onAuthStateChanged((user) => {
          if (user) {
            user
              .getIdToken(/* forceRefresh */ true)
              .then((idToken) => {
                let new_session = JSON.parse(
                  localStorage.getItem("login_result")
                );
                new_session.access_token = idToken;
                new_session.expiry_date = Date.now() + 50 * 60000;
                localStorage.setItem(
                  "login_result",
                  JSON.stringify(new_session)
                );
              })
              .catch((err) => {
                catch_error(err);
              });
          }
        });
      }
    }
  }
});
